import * as Yup from 'yup';
import { matcherPhoneNumberIsValid } from '../utils';

const matcherPhoneSchema = Yup.object().shape({
  phone: Yup.string()
    .trim()
    .required('Please enter your phone number.')
    .test(
      'test-phone',
      'Please enter a valid phone number.',
      matcherPhoneNumberIsValid
    )
});

export { matcherPhoneSchema };
